import React from 'react';
import { Box, Typography, Button, Switch, FormControlLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export default function PerformMaintenance() {
  const [showAllCustomers, setShowAllCustomers] = React.useState(() => {
    const stored = localStorage.getItem('showAllCustomers');
    return stored === 'true';
  });
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Perform Maintenance
      </Typography>
      <FormControlLabel
        control={<Switch checked={showAllCustomers} onChange={e => {
          setShowAllCustomers(e.target.checked);
          localStorage.setItem('showAllCustomers', e.target.checked);
        }} />}
        label="Show All Customers (Override Today's Filter)"
        sx={{ mb: 2 }}
      />
      <Button variant="contained" sx={{ mb: 2 }} onClick={() => navigate('/todo')}>
        To Do List
      </Button>
      <Button variant="contained" sx={{ mb: 2, ml: 2 }} onClick={async () => {
        const apiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '';
        try {
          const azureClientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || process.env.AZURE_AD_CLIENT_ID;
          const apiScope = `api://${azureClientId}/access_as_user`;
          console.log("API Scope:", apiScope);
          const request = {
            scopes: [apiScope],
            account: accounts[0]
          };
          const response = await instance.acquireTokenSilent(request);
          const accessToken = response.accessToken;

          const res = await fetch(`${apiBase}/api/technicians/sync-deputy`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            }
          });

          let data;
          try {
            data = await res.json();
          } catch (jsonErr) {
            const text = await res.text();
            alert('Mongo Sync failed: ' + text);
            return;
          }
          if (data.success) {
            alert('Mongo Sync completed successfully!');
          } else {
            alert('Mongo Sync failed: ' + (data.error || 'Unknown error'));
          }
        } catch (err) {
          alert('Mongo Sync failed: ' + err.message);
        }
      }}>
        Mongo Sync
      </Button>
      <Button variant="contained" sx={{ mb: 2, ml: 2 }} onClick={async () => {
        const apiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '';
        try {
          const azureClientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || process.env.AZURE_AD_CLIENT_ID;
          const apiScope = `api://${azureClientId}/access_as_user`;
          const request = {
            scopes: [apiScope],
            account: accounts[0]
          };
          const response = await instance.acquireTokenSilent(request);
          const accessToken = response.accessToken;

          const res = await fetch(`${apiBase}/api/sync-control/run-chargebee-subscription-full-sync`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            }
          });

          let data;
          try {
            data = await res.json();
          } catch (jsonErr) {
            const text = await res.text();
            alert('CB→HS Subscription Sync failed: ' + text);
            return;
          }
          if (data.success) {
            alert('Full CB→HS Subscription Sync started/completed.');
          } else {
            alert('CB→HS Subscription Sync failed: ' + (data.error || 'Unknown error'));
          }
        } catch (err) {
          alert('CB→HS Subscription Sync failed: ' + err.message);
        }
      }}>
        Full CB→HS Subscription Sync
      </Button>
      <Button variant="contained" sx={{ mb: 2, ml: 2 }} onClick={async () => {
        const apiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '';
        try {
          const azureClientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || process.env.AZURE_AD_CLIENT_ID;
          const apiScope = `api://${azureClientId}/access_as_user`;
          const request = {
            scopes: [apiScope],
            account: accounts[0]
          };
          const response = await instance.acquireTokenSilent(request);
          const accessToken = response.accessToken;

          const res = await fetch(`${apiBase}/api/sync-control/run-scheduled-services-sync`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            }
          });
          let data;
          try {
            data = await res.json();
          } catch (jsonErr) {
            const text = await res.text();
            alert('Scheduled Customers Today Sync failed: ' + text);
            return;
          }
          if (data.success) {
            alert('Scheduled Customers Today successfully re-synced!');
          } else {
            alert('Scheduled Customers Today Sync failed: ' + (data.error || 'Unknown error'));
          }
        } catch (err) {
          alert('Scheduled Customers Today Sync failed: ' + err.message);
        }
      }}>
        Re-sync Scheduled Customers Today
      </Button>
      <Button variant="contained" sx={{ mb: 2, ml: 2 }} onClick={async () => {
        const apiBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '';
        try {
          const azureClientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || process.env.AZURE_AD_CLIENT_ID;
          const apiScope = `api://${azureClientId}/access_as_user`;
          const request = {
            scopes: [apiScope],
            account: accounts[0]
          };
          const response = await instance.acquireTokenSilent(request);
          const accessToken = response.accessToken;

          const res = await fetch(`${apiBase}/api/sync-control/send-daily-report`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            }
          });
          let data;
          try {
            data = await res.json();
          } catch (jsonErr) {
            const text = await res.text();
            alert('Daily Report send failed: ' + text);
            return;
          }
          if (data.success) {
            alert('Daily Report email sent successfully!');
          } else {
            alert('Daily Report send failed: ' + (data.error || 'Unknown error'));
          }
        } catch (err) {
          alert('Daily Report send failed: ' + err.message);
        }
      }}>
        Send Daily Report Email
      </Button>
    </Box>
  );
}

// To use this override in the field form, pass showAllCustomers as a prop or via a global state/store.
// Example: <TechnicianForm showAllCustomers={showAllCustomers} />
// And update TechnicianForm/useScheduledServicesToday to accept and forward this prop.

// Renamed from TestModule to PerformMaintenance
